// src/components/admin/SubfieldSummary.js - WERSJA Z JEDNĄ KOLUMNĄ

import React, { useState, useEffect } from 'react';
import { RenderMarkdownWithLatex } from '../../utils/utils';

const apiUrl = process.env.REACT_APP_API_SOURCE;
const token = localStorage.getItem("token");

const SubfieldSummary = ({ subfieldId }) => {
    const [summaryData, setSummaryData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!subfieldId) return;

        setIsLoading(true);
        setError(null);
        setSummaryData(null);

        fetch(`${apiUrl}subfield-summary/${subfieldId}/`, {
            headers: { "Content-Type": "application/json", Authorization: `Token ${token}` }
        })
        .then(res => {
            if (!res.ok) throw new Error("Nie udało się pobrać podsumowania poddziału.");
            return res.json();
        })
        .then(data => {
            setSummaryData(data);
        })
        .catch(err => {
            setError(err.message);
        })
        .finally(() => {
            setIsLoading(false);
        });

    }, [subfieldId]);

    if (isLoading) {
        return <div className="bg-white p-4 rounded-lg shadow mb-6 text-center">Ładowanie podsumowania...</div>;
    }

    if (error) {
        return <div className="bg-red-50 p-4 rounded-lg shadow mb-6 text-red-700 text-center">{error}</div>;
    }

    if (!summaryData) {
        return null;
    }

    const TemplateListItem = ({ template }) => (
        <li key={template.problem_id} className="text-xs p-2 border-l-4 border-purple-300 bg-purple-50 rounded-r">
            <p className="font-bold text-purple-800">Szablon ID: {template.problem_id}</p>
            <div className="text-gray-700 italic"><RenderMarkdownWithLatex text={template.question} /></div>
        </li>
    );

    const MaturaProblemListItem = ({ problem }) => (
        <li key={problem.matura_problem_id} className="text-xs p-2 border-l-4 border-green-300 bg-green-50 rounded-r">
            <div className="text-gray-700"><RenderMarkdownWithLatex text={problem.matura_problem_question} /></div>
            <p className="font-bold text-green-800 text-right">({problem.matura_problem_source})</p>
        </li>
    );


    return (
        <div className="bg-white p-6 rounded-lg shadow-lg mb-6">
            <h2 className="text-xl font-bold mb-1 text-gray-800">Podsumowanie Poddziału: <span className="text-blue-600">{summaryData.subfield_name}</span></h2>
            <p className="text-sm text-gray-500 mb-6 border-b pb-4">Próg ELO: <span className="font-semibold">{summaryData.elo_threshold}</span></p>

            {/* --- ZMIANA UKŁADU: Wszystko w jednej kolumnie, oddzielone większym marginesem --- */}
            <div className="space-y-8">
                <div>
                    <h3 className="text-lg font-semibold mb-2">Używane Szablony ({summaryData.distinct_templates.length})</h3>
                    {/* Usunięto ograniczenie wysokości i przewijanie */}
                    <ul className="space-y-2 pr-2">{summaryData.distinct_templates.map(t => <TemplateListItem key={t.problem_id} template={t} />)}</ul>
                </div>
                
                <div>
                    <h3 className="text-lg font-semibold mb-2">Używane Zadania Maturalne ({summaryData.distinct_matura_problems.length})</h3>
                    {/* Usunięto ograniczenie wysokości i przewijanie */}
                    <ul className="space-y-2 pr-2">{summaryData.distinct_matura_problems.map(p => <MaturaProblemListItem key={p.matura_problem_id} problem={p} />)}</ul>
                </div>
            
                <div>
                    <h3 className="text-lg font-semibold mb-2">Mapa: Szablon → Zadania Maturalne</h3>
                    {/* Usunięto ograniczenie wysokości i przewijanie */}
                    <div className="space-y-3 pr-2">
                        {summaryData.template_to_matura_map.map(mapping => (
                            <div key={mapping.template.problem_id} className="border p-3 rounded-md shadow-sm">
                                <TemplateListItem template={mapping.template} />
                                <ul className="pl-6 mt-2 space-y-1">{mapping.matura_problems.map(p => <MaturaProblemListItem key={p.matura_problem_id} problem={p} />)}</ul>
                            </div>
                        ))}
                    </div>
                </div>
           
                <div>
                    <h3 className="text-lg font-semibold mb-2">Mapa: Zadanie Maturalne → Szablony</h3>
                    {/* Usunięto ograniczenie wysokości i przewijanie */}
                    <div className="space-y-3 pr-2">
                        {summaryData.matura_to_template_map.map(mapping => (
                            <div key={mapping.matura_problem.matura_problem_id} className="border p-3 rounded-md shadow-sm">
                                <MaturaProblemListItem problem={mapping.matura_problem} />
                                <ul className="pl-6 mt-2 space-y-1">{mapping.templates.map(t => <TemplateListItem key={t.problem_id} template={t} />)}</ul>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubfieldSummary;